
/* injects from baggage-loader */

'use strict';

import { fill } from 'lodash';

export default class StatusBarController {
    constructor($log, $scope, $rootScope, Session, $timeout) {
        'ngInject';
        this.$log = $log;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.Session = Session;

        this.$rootScope.$on('update:status-bar', this.onUpdateStatus.bind(this))
    }

    $onInit(){
        this.user = this.Session.get().user;
    }

    getLifesAsArray(){
        let lifes = [];

        if(this.user){
            lifes = fill(Array(this.user.life), "");
        }

        return lifes;
    }
    
    onUpdateStatus(){
        this.user = this.Session.get().user;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/ui/status-bar/status-bar.controller.js